export const REQUIERED = "Bitte ausfüllen.";
export const TOO_SHORT = (length: number) =>
  `The input must be at least ${length} characters long.`;
export const TOO_LONG = (length: number) =>
  `The input must be at most ${length} characters long.`;
export const NOT_A_NUMBER = "Please only numbers.";
export const INVALID_EMAIL = "Please enter a correct email.";
export const INVALID_USERNAME =
  "Username can only contain letters, numbers, and ._-";
export const INVALID_USERNAME_DESCRIPTION =
  "Deine Beschreibung darf nur Buchstaben, Nummern und folgende Sonderzeichen enthalten ._-";
